"use strict";

const body = document.querySelector('body');
const headerLink = document.querySelector('header#header .standard-container a');
const main = document.querySelector('main');

let scrollStart = 0;
let differenceDown = 0;
let differenceUp = 0;

window.addEventListener('scroll', checkScrollPosition);
checkForHomePage();
checkForHeaderImage();

function checkScrollPosition() {
    if(!body.classList.contains('menu-open')) {
        if(scrollStart > window.scrollY) {
            differenceDown += (scrollStart - window.scrollY);
            if(window.scrollY === 0 || differenceDown >= 10) {
                body.classList.remove('header-fade-out');
            }
            differenceUp = 0;
        } else {
            differenceUp += (window.scrollY - scrollStart);
            if(window.scrollY > 200 && differenceUp >= 50) {
                body.classList.add('header-fade-out');
            }
            differenceDown = 0;
        }
    }
    scrollStart = window.scrollY;
}

function checkForHomePage() {
    if(headerLink.firstElementChild.tagName === 'svg') {
        body.classList.add('sub-page');
    }
}

function checkForHeaderImage() {
    if(!main.firstElementChild.classList.contains('header-image')) {
        main.classList.add('no-header-image');
    }
}
